import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Span, ChevronLeftIcon, LoadingDots, Text } from '@/components/atoms'
import { usePaymentInUpdatePage } from './page.payment-in-update.hook'
import { ROUTES } from '@/shared/constants/routes'
import { PaymentPage } from '../page.payment'

interface PaymentInUpdatePageProps {
  onClose?: () => void
  isVisible?: boolean
}

export function PaymentLayoutWithPayIn() {
  return <PaymentPage initialModal="payIn" />
}

export function PaymentInUpdatePage({
  onClose,
  isVisible = true,
}: PaymentInUpdatePageProps = {}) {
  const { t } = useTranslation()
  const { keycloakLoading, keycloakError, isOffline } = usePaymentInUpdatePage(
    isVisible,
    onClose,
  )

  return (
    <div className="flex flex-col md:px-8">
      {!onClose && (
        <div className="px-4 pt-6">
          <Link
            to={ROUTES.PAYMENT}
            className="flex items-center gap-1 text-sm text-neutral-600"
          >
            <ChevronLeftIcon />
            {t('payment.back')}
          </Link>
        </div>
      )}

      <div className={onClose ? '' : 'px-4 py-6'}>
        <div className="mt-2 text-center">
          {keycloakLoading && (
            <div className="mt-4 flex justify-center">
              <LoadingDots />
            </div>
          )}
          {keycloakError && (
            <Span className="mb-4 block text-red-600">
              {t('payment.updatePayIn.error')}
            </Span>
          )}
          {isOffline && (
            <Text className="text-indigo-base !text-sm">
              {t('payment.offlineError')}
            </Text>
          )}
        </div>
      </div>
    </div>
  )
}
